/** Solid outlined chrome shared by static cards (StatBlock, dashboard sections, day-progress frame). */
export const STATIC_CARD_BORDER_SX = {
  border: 1,
  borderColor: 'divider',
  borderRadius: 1.5,
  boxSizing: 'border-box',
};
